import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidGen } from 'uuid';

import { fetchAdsSegmentData } from '../api';

// TODO: a response that resolves after a logout or re-login still puts the previous user's ads
// segment back after resetAmexAds(). Drop late results when the session changed, as
// requestUserThunk does with userSessionGeneration in userSlice (would need the generation shared
// outside userSlice).
const getAmexAdsSegmentThunk = createAsyncThunk(
  'amexAds/getAmexAdsSegmentThunk',
  ({
    requestPage,
    useBackendApi,
    encryptedResyAdsId,
  }) => fetchAdsSegmentData({
    requestPage,
    useBackendApi,
    encryptedResyAdsId,
    correlationId: uuidGen(),
  })
);

const amexAdsSlice = createSlice({
  name: 'amexAds',
  initialState: {
    isLoading: true,
    flags: null,
    payload: null,
    error: null,
  },
  reducers: {
    resetAmexAds: (state) => {
      state.isLoading = true;
      state.flags = null;
      state.payload = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAmexAdsSegmentThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.flags = null;
      state.payload = null;
    });
    builder.addCase(getAmexAdsSegmentThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.flags = action.payload?.flags;
      state.payload = action.payload?.payload;
    });
    builder.addCase(getAmexAdsSegmentThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
      state.flags = null;
      state.payload = null;
    });
  },
});

const { resetAmexAds } = amexAdsSlice.actions;

const fetchAmexAdsSegmentThunk = ({
  requestPage,
  useBackendApi,
  encryptedResyAdsId,
}) => (dispatch) => dispatch(getAmexAdsSegmentThunk({
  requestPage,
  useBackendApi,
  encryptedResyAdsId,
}));

export { fetchAmexAdsSegmentThunk, getAmexAdsSegmentThunk, resetAmexAds };

export default amexAdsSlice.reducer;
